export default __webpack_public_path__ + "static/media/policy-glyph-16px.69cbee19.svg";